import { Injectable, Injector } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../environments/environment';
import { UserService } from './services/user.service';

@Injectable()
export class CustomHttpInterceptor implements HttpInterceptor {

  constructor(public injector: Injector) {
    this.injectServices();
  }

  userService: any;

  injectServices() {
    setTimeout(()=>{
      if(!this.userService) {
        this.userService = this.injector.get(UserService);
      }
    }, 0);
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let w = (<any>window),
    requestObject: any = request;

 
    requestObject = w.apiUrlFormatter.addQueryParamToUrl(requestObject, 'inhibitLayer', w.mmap.getInhibitLayer(null));
    requestObject = w.apiUrlFormatter.addQueryParamToUrl(requestObject, 'organizationId', w.mmapOrganizationId);
    if(w.mmap.addOrganizationGlobalId()) {
      requestObject = w.apiUrlFormatter.addQueryParamToUrl(requestObject, 'organizationGlobalId', w.mmap.getOrganizationGlobalId());
    }

    request = request.clone({
      withCredentials: true,
      url: requestObject.url
    });

    return next.handle(request);
  }
}


// WEBPACK FOOTER //
// ./src/app/app.interceptor.ts